const state = {
    isOpen: false,
    wallet : {}
};

const getters = {
    isOpen(state) {
        return state.isOpen;
    },
    wallet(state){
        
        return state.wallet
    }
};

const actions = {
    toggleOpen(context){
        context.commit('isOpen', !context.state.isOpen)
    },
    isOpen(context, open){
        context.commit('isOpen', open)
    },
    setWallet(context , wallet){
        context.commit('wallet' , wallet)
    }
};

const mutations = {
    isOpen(state, open) {
        state.isOpen = open;
    },
    wallet(state, wallet){
        state.wallet = wallet;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
